import { render, staticRenderFns } from "./ReportResult.vue?vue&type=template&id=3c1fa781&"
import script from "./ReportResult.vue?vue&type=script&lang=js&"
export * from "./ReportResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports